module.exports = __webpack_public_path__ + "img/eliminar blanco.c0d6aa63.svg";